var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('clip-loader',{staticClass:"prompt-loader",attrs:{"loading":true,"color":"#949494","size":"100px"}}),_c('b',{staticClass:"prompt-header"},[_c('br'),_vm._v(_vm._s(_vm.message)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }